let Translations = {
    fr: {
        back: 'back',
        close: 'close',
        create: 'create',
        delete: 'delete',
        lock: 'lock',
        reset: 'reset',
        save: 'save'
    },
    en: {
        back: 'back',
        close: 'close',
        create: 'create',
        delete: 'delete',
        lock: 'lock',
        reset: 'reset',
        save: 'save'
    },
    zh: {
        back: 'back',
        close: 'close',
        create: 'create',
        delete: 'delete',
        lock: 'lock',
        reset: 'reset',
        save: 'save'
    }
};
export {Translations}